import { createFileRoute, retainSearchParams } from '@tanstack/react-router';

import CasesV2 from '~/app/praetors/cases/CasesV2/CasesV2';
import { type GlobalSelection, parseValidDateRange } from '~/lib/useGlobalFilter';

export type CaseSeverityFilter = 'all' | 'high' | 'medium' | 'low';

export interface PraetorCasesSearchParams {
	type?: 'violation' | 'all';
	severity?: CaseSeverityFilter;
	thread?: string;
	start?: string;
	end?: string;
	page?: number;
}

const SEVERITY_VALUES: CaseSeverityFilter[] = ['all', 'high', 'medium', 'low'];

function parsePage(value: unknown): number {
	const page = Number(value);
	return Number.isInteger(page) && page > 0 ? page : 1;
}

export const Route = createFileRoute('/_app/home/praetors/$praetorId/cases')({
	validateSearch: (search): PraetorCasesSearchParams => {
		const dateRange = parseValidDateRange(search.start, search.end);
		const severity: CaseSeverityFilter =
			typeof search.severity === 'string' &&
			(SEVERITY_VALUES as readonly string[]).includes(search.severity)
				? (search.severity as CaseSeverityFilter)
				: 'all';

		return {
			type: (search.type as PraetorCasesSearchParams['type']) ?? 'all',
			severity,
			thread: typeof search.thread === 'string' ? search.thread : undefined,
			page: parsePage(search.page),
			...dateRange
		};
	},
	search: {
		middlewares: [
			retainSearchParams<GlobalSelection & PraetorCasesSearchParams>([
				'type',
				'severity',
				'thread',
				'start',
				'end',
				'page'
			])
		]
	},
	beforeLoad: () => ({
		getTitle: undefined
	}),
	component: CasesV2
});
